import { render } from "./ReportesFeedbackNew.vue?vue&type=template&id=5ab1e165&scoped=true"
import script from "./ReportesFeedbackNew.vue?vue&type=script&lang=js"
export * from "./ReportesFeedbackNew.vue?vue&type=script&lang=js"

import "./ReportesFeedbackNew.vue?vue&type=style&index=0&id=5ab1e165&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab1e165"]])

export default __exports__